import { BehaviorSubject } from 'rxjs';
import url from "./../components/variables/url.js";

const APP_ID = process.env.REACT_APP_ID;
/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const casF = url.CAS_FOTO;
const foto = url.foto;

const currentUser = {
  usuario: "",
  idpersona: 0,
  identificacion: "",
  ultimoCambio: "",
  apellidos: "",
  nombres: "",
  roles: [],
  foto: "",
  token: "",
  estudianteGrado: false,
  estudiantePostgrado: true,
  ProgramasPostgrado: []
};

const currentUserSubject = new BehaviorSubject(currentUser);

export const authService = {
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() { return currentUserSubject.value },
};

function login(username) {
    
    fetch(localBack + "/api/Account", {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ idapp: APP_ID, netid: username })
    })
        .then(response => response.json())
        .then((result) => {

            let loggedUser = {
                idpersona: result.user.idpersona,
                matricula: result.user.codestudiante,
                usuario: result.user.netId,
                identificacion: result.user.numeroidentificacion,
                apellidos: result.user.apellidos,
                nombres: result.user.nombres,
                roles: result.user.roles,
                foto: result.user.foto,
                token: result.token,          
                estudianteGrado: result.estudianteGrado,
                estudiantePostgrado: result.estudiantePostgrado,
                ProgramasPostgrado: result.ProgramasPostgrado,
            };

            let realFetch = window.fetch;
            window.fetch = function (url, opts = null) {
                let headers = opts.headers;
                /*console.log("fetch opts = " + JSON.stringify(opts.headers));*/
                if (loggedUser.token) {
                    headers = Object.assign({}, headers, { 'Authorization': `Bearer ${loggedUser.token}` });
                    //console.log("fileupload = " + url.indexOf('FileUpload'));
                    //console.log("content-type = " + headers['Content-Type']);
                    if (url.indexOf('FileUpload') < 0 && headers['Content-Type'] == undefined) {
                        /*console.log("add content-type");*/
                        headers = Object.assign({}, headers, { 'Content-Type': 'application/json' });
                        //opts = Object.assign({}, opts, { 'headers': { 'Content-Type': 'application/json'} });
                    }
                    //opts = Object.assign({}, opts, { 'headers': { 'Authorization': `Bearer ${loggedUser.token}` } });
                    opts.headers = headers;
                    /*console.log(JSON.stringify(opts));*/
                    return realFetch(url, opts);
                } else {
                    return realFetch(url, opts);
                }
            };

            currentUserSubject.next(loggedUser);
        });
  
}

function logout() {
  // remove user and go to logout CAS
  currentUserSubject.next(null);
  window.location.href = "/Account/Logout";
}
